export const COVERAGE = {
  openCoverageMapButton: "open-coverage-map-button",
  mapContainer: "coverage-map-container",
  mapSearchInput: "coverage-search-input",
  mapStatusFilter: "coverage-status-filter",
  mapSidebarItem: "coverage-sidebar-item",
  mapPopupWhatsAppButton: "coverage-popup-whatsapp-button",
  mapPopupCallButton: "coverage-popup-call-button",
  mapPopupRequestButton: "coverage-popup-request-button",
  adminPasswordInput: "coverage-admin-password-input",
  adminUnlockButton: "coverage-admin-unlock-button",
  adminForm: "coverage-admin-form",
  adminAddButton: "coverage-admin-add-button",
  adminEditButton: "coverage-admin-edit-button",
  adminDeleteButton: "coverage-admin-delete-button",
  adminSaveButton: "coverage-admin-save-button",
};
